import React from 'react';
import NavRouter from "./router/NavRouter";
import "bootstrap/dist/css/bootstrap.min.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// animate.css loaded dynamically after page paint (not render-blocking)
import "./App.css";
import "./style.css";
import "./responsive.css";
import { useEffect, useState } from "react";
import SEO from "./helper/SEO";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import { BaseUrl } from "./helper/BaseUrl";
import { ModalProvider } from './contexts/ModalContext';

function App({ initialData, initialSeo, initialGlobalSchema }) {
  const [seoData, setSeoData] = useState(initialSeo || null);
  const [globalSchema, setGlobalSchema] = useState(initialGlobalSchema || null);
  const location = useLocation();

  useEffect(() => {
    const controller = new AbortController();

    const Detailfetcher = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/seo-by-url${location.pathname}`, {
          method: 'GET',
          signal: controller.signal,
        });
        const result = await response.json();
        if (result.seo === false) {
          throw new Error(`API error: ${result.message}`);
        }
        setSeoData(result.seo);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error('Fetch error:', error.message);
        }
      }
    };

    Detailfetcher();
    return () => controller.abort();
  }, [location.pathname])

  useEffect(() => {
    const controller = new AbortController();

    const fetchGlobalSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/global-seo`, {
          method: 'GET',
          signal: controller.signal,
        });
        const result = await response.json();
        setGlobalSchema(result.schema);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error('Schema fetch error:', error.message);
        }
      }
    };

    fetchGlobalSchema();
    return () => controller.abort();
  }, []);


  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("source_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("source_url", landingUrl);
      }
    }
  }, []);

  useEffect(() => {
    // Load animate.css + WOW.js after first paint so they don't block rendering
    if (typeof window !== "undefined") {
      // Inject animate.css asynchronously
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "/animate.min.css";
      // Use requestIdleCallback to defer until browser is idle
      const load = () => document.head.appendChild(link);
      if ("requestIdleCallback" in window) {
        requestIdleCallback(load, { timeout: 2000 });
      } else {
        setTimeout(load, 500);
      }

      // Load WOW.js after animate.css is ready
      link.onload = () => {
        import("wowjs").then(({ WOW }) => {
          const wow = new WOW({ live: false, mobile: true });
          wow.init();
        });
      };
    }
  }, []);
  return (

    <div className="App">
      <SEO seoData={seoData} initialSeo={initialSeo} globalSchema={globalSchema} />
      <ModalProvider>
        <NavRouter initialData={initialData} />
      </ModalProvider>
      <ToastContainer />
    </div>


  );
}

export default App;
